/**
 * Constants for exhibited column on exhibitionwork
 */

export const EXHIBITED_OPTIONS = [
  { label: "Not Shown", value: 0 },
  { label: "Shown", value: -1 },
  { label: "1st Day", value: 1 },
  { label: "2nd Day", value: 2 },
  { label: "3rd Day", value: 3 },
  { label: "4th Day", value: 4 },
  { label: "5th Day", value: 5 },
  { label: "Viewing Room", value: 6 },
  { label: "Back Room", value: 7 },
];
